

import {defaultLocale, LOCALE_STORAGE_KEY} from '@/app/config'
import {localize} from '@plugins/vee-validate'
import {locales} from '@plugins/vue-i18n/register'
import {camelCase, isString} from 'lodash'
import {mapActions, mapGetters, mapMutations} from 'vuex'

const defaultAxiosCountDown = 310
const selectedSubItem= null;
export default {
  methods: {
    IsAppLocale(locale) {
      return this.AppLocales.find(l => l.code === locale)
    },
    SetAppLocale(locale) {
      this.AppLocale = locale
      this.$nextTick(() => window.location.reload())
    },
    IniAppLocale() {
      this.AppLocale = localStorage.getItem(LOCALE_STORAGE_KEY) || defaultLocale
    },
    getPageTitle() {
      const t = (...a) => this.$t(...a);
      const tc = (...a) => this.$tc(...a);
      const e = (...a) => this.$te(...a);
      const _ = this.$_
      let str = '';
      let {name, pageName} = this.$options || {};
      let routePath = this.$route.path.split('/').pop();
      let routeName = this.$route.name.split('/').pop();
      if(routePath && e(routePath) && isString((str = t(routePath)))) {
        return str
      }
      routePath = camelCase(routePath)
      if(routePath && e(routePath) && isString((str = t(routePath)))) {
        return str
      }
      if(routeName && e(routeName) && isString((str = t(routeName)))) {
        return str
      }

      routeName = camelCase(routeName)
      if(routeName && e(routeName) && isString((str = t(routeName)))) {
        return str
      }
      let $routes
      let $routes2
      $routes = `$routes.${routeName}`
      $routes2 = `$routes.${routeName}`
      if(routeName && e($routes) && isString((str = t($routes)))) {
        return str
      }
      if(routeName && e($routes2) && isString((str = t($routes2)))) {
        return str
      }
      let pluralize = _.pluralize(_.upperFirst(routeName.split('Index').join('').split('index').join('')))
      pluralize = pluralize.split('Client').join('').split('client').join('');
      $routes = `choice.${pluralize}`;
      if($routes && e($routes) && isString((str = tc($routes, 2)))) {
        return str
      }

      if(e(`${name}.name`) && isString((str = t(`${name}.name`)))) {
        return str
      }

      if(e(name) && isString((str = t(name)))) {
        return str
      }

      name = camelCase(name)
      if(e(`${name}.name`) && isString((str = t(`${name}.name`)))) {
        return str
      }

      if(e(name) && isString((str = t(name)))) {
        return str
      }

      if(e(pageName) && isString((str = t(pageName)))) {
        return str
      }

      return ''
    },
    getPageName() {
      let returnOBJ = {};
      let routeName = this.$route.name.split('/').pop()
      returnOBJ.name = camelCase(routeName.split('Index').join('').split('index').join(''))
      returnOBJ.name = camelCase(routeName.split('Client').join('').split('client').join(''))
      returnOBJ.nameStudly = this.$_.upperFirst(returnOBJ.name)
      return returnOBJ;
    },
    getModelName() {
      let ret = {};
      let routeN = this.$route.name.split('/').pop()
      ret.name = camelCase(routeN.split('Index').join('').split('index').join(''))
      ret.name = camelCase(routeN.split('Client').join('').split('client').join(''))
      ret.nameStudly = this.$_.upperFirst(ret.name)
      ret.namePlural = this.$_.pluralize(ret.nameStudly)
      return ret;
    },
    parseAttribute(string, ...args) {
      if(!string) return string

      const _ = this.$_, t = (...a) => this.$t(...a), te = (...a) => this.$te(...a)

      let key = (this.$helpers.isOnlyObject(string) ? (string.text || '') : string).toString()

      if(te(key) && isString(t(key)))
        return t(key, ...args)

      if(te(`attributes.${key}`) && isString(t(`attributes.${key}`)))
        return t(`attributes.${key}`, ...args)

      return string
    },
    HasEditPermission() {
      // console.log(this.getPageName().name + '_edit');
      return this.HasPermission(this.getModelName().name + '_edit');
    },
    HasDeletePermission() {
      return this.HasPermission(this.getModelName().name+'_delete');
    },
    HasPermission(string) {
      if(!string) return false

      let allowedperms = JSON.parse(localStorage.getItem('perms'));

      if(allowedperms){
        if(allowedperms[string]){
          return true;
        }
      }
      return false
    },
    getAxiosName() {
      return this.$options.name
    },
    getAxiosItems() {
      return this.getIniAxios(this.getAxiosName())
    },
    carstutasnames(va) {
      if(va){
        return this.$t('attributes.carstutas'+va)
      }

      return '-';
    },
    carstutasobject() {
      return [
        {
          text: this.$t('attributes.carstutas0'),
          value: 0
        },
        {
          text: this.$t('attributes.carstutas1'),
          value: 1
        },
        {
          text: this.$t('attributes.carstutas2'),
          value: 2
        },
        {
          text: this.$t('attributes.carstutas3'),
          value: 3
        },
        {
          text: this.$t('attributes.carstutas4'),
          value: 4
        },
        {
          text: this.$t('attributes.carstutas5'),
          value: 5
        },
        {
          text: this.$t('attributes.carstutas6'),
          value: 6
        },
        {
          text: this.$t('attributes.carstutas7'),
          value: 7
        },
        {
          text: this.$t('attributes.carstutas8'),
          value: 8
        }
      ]
    },
    menutypes() {
      return [
        {
          text: this.$t('attributes.menu_type1'),
          value: 1
        },
        {
          text: this.$t('attributes.menu_type2'),
          value: 2
        }
      ]
    },
    product_types() {
      return [
        {
          text: this.$t('attributes.product_type1'),
          value: 1
        },
        {
          text: this.$t('attributes.product_type2'),
          value: 2
        }
      ]
    },
    setIniAxios(name, v) {
      this.$root.iniAxios[name] = v
    },
    getIniAxios(name) {
      return null
    },
    increaseAxios(countdown = defaultAxiosCountDown) {
      countdown = parseInt(countdown) || defaultAxiosCountDown
      this.$root.AxiosCountdown += countdown
      // console.log(this.$root.AxiosCountdown);
      return this.getAxiosCountdown()
    },
    setAxiosCountdown(countdown = defaultAxiosCountDown) {
      this.$root.AxiosCountdown = countdown
    },
    getAxiosCountdown() {
      return this.$root.AxiosCountdown
    },
    queueAxios(func, countdown = defaultAxiosCountDown) {
      // console.log(countdown);
      setTimeout(() => setTimeout(() => this.$nextTick(func), this.increaseAxios(countdown)), 60)
    },
  },
  computed: {
    APP_DEBUG: () => process.env.NODE_ENV === 'development',
    DefaultAppLocale: () => defaultLocale,
    AppRtl: {
      set(v) {
        this.$root.$vuetify.rtl = v
      },
      get() {
        const {rtl} = this.$root.$vuetify || {}
        return rtl !== undefined ? rtl : true
      }
    },
    AppName2() {
      return !this.AppRtl?process.env.MIX_APP_NAME:process.env.MIX_APP_NAME2;
    },
    Permissions: {
      set(v) {

      },
      get() {
        return JSON.parse(localStorage.getItem('perms'));
      }
    },
    AppDirection: {
      set(v) {
        this.AppRtl = v.toLowerCase() === 'rtl'
      },
      get() {
        return this.AppRtl ? 'rtl' : 'ltr'
      }
    },
    AppAlign: {
      set(v) {
        this.AppRtl = v.toLowerCase() === 'right'
      },
      get() {
        return this.AppRtl ? 'right' : 'left'
      }
    },
    AppOpositeAlign: {
      set(v) {
        this.AppRtl = v.toLowerCase() === 'left'
      },
      get() {
        return this.AppRtl ? 'left' : 'right'
      }
    },
    AppLocales() {
      return locales.map(code => ({title: this.$t(code), code}))
    },
    identity_types() {
      return [
        {
          text: this.$t('attributes.identity_type1'),
          value: 1
        },
        {
          text: this.$t('attributes.identity_type2'),
          value: 2
        }
      ]
    },
    identity_statuses() {
      return [
        {
          text: this.$t('attributes.identity_status0'),
          value: 0
        },
        {
          text: this.$t('attributes.identity_status1'),
          value: 1
        },
        {
          text: this.$t('attributes.identity_status2'),
          value: 2
        },
        {
          text: this.$t('attributes.identity_status3'),
          value: 3
        },
        {
          text: this.$t('attributes.identity_status4'),
          value: 4
        },
      ]
    },
    user_types() {
      return [
        {
          text: this.$t('attributes.user_type0'),
          value: 0
        },
        {
          text: this.$t('attributes.user_type1'),
          value: 1
        },
        {
          text: this.$t('attributes.user_type2'),
          value: 2
        },
        {
          text: this.$t('attributes.user_type3'),
          value: 3
        }
      ]
    },
    user_statuses() {
      return [
        {
          text: this.$t('attributes.user_status1'),
          value: 1
        },
        {
          text: this.$t('attributes.user_status2'),
          value: 2
        },
        {
          text: this.$t('attributes.user_status3'),
          value: 3
        }
      ]
    },
    AppLocale: {
      set(locale = defaultLocale) {
        locale = ('' + locale).toString().toLocaleLowerCase()

        !this.IsAppLocale(locale) && (locale = defaultLocale)

        localStorage.setItem(LOCALE_STORAGE_KEY, locale)
        document.documentElement.setAttribute('lang', locale)
        document.documentElement.setAttribute('dir', locale === 'ar' ? 'rtl' : 'ltr')

        // Vuetify
        this.$root.$i18n.locale = locale
        this.$root.$vuetify.lang.current = locale
        this.$root.$vuetify.rtl = locale === 'ar'

        // axios
        this.$axios.defaults.headers.common['Locale'] = locale

        // Vuex
        const validations = require(`@locales/${locale}/validations.js`).default
        localize(locale, validations.default || validations)

        // moment js
        this.$moment.locale(locale)
      },
      get() {
        return this.$root.$vuetify.lang.current
      }
    },
    themeDark: {
      get() {
        return Boolean(mapGetters('auth', ['themeDark']).themeDark.call(this))
      },
      set(value) {
        this.$vuetify.theme.dark = value
        mapActions('auth', ['setThemeDark']).setThemeDark.call(this, value)
      }
    },
    themeLight: {
      get() {
        // console.log(this.themeDark)
        return !Boolean(this.themeDark)
      },
      set(value) {
        value = !value
        this.$vuetify.theme.dark = value
        mapActions('auth', ['setThemeDark']).setThemeDark.call(this, value)
      }
    },
    themeColor() {
      return this.themeDark ? 'dark' : 'light'
    },
    AppIsMobile() {
      return this.$root.$vuetify.breakpoint.smAndDown || false
    },
    authUser: {
      set(user) {
        mapMutations('auth', ['setUser']).setUser.call(this, user)
      },
      get() {
        return mapGetters('auth', ['getUser']).getUser.call(this)
      }
    },
    updateAuthUser: {
      get() {
        return mapGetters('auth', ['getUser']).getUser.call(this)
      }
    },
    apiService() {
      return this.$api.methods
    },
  }
}
